export const environment = {
  production: false,
  apiEndpoint: 'https://api.centralcpd.com',
  touch: true,
  frontendUrl: 'https://www.centralcpd.com'
};